import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaRegister.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputEmail, Button, H3, Content, FormGroup, MailIcon } from "AtomicComponents"
import { HeroContent, AlertList } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formSetDefaultValues, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import urlHandler from "AtomicUtils/urlHandler"

class MyMazdaRegister extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  componentDidMount() {
    const { email } = this.props

    if (email) {
      formSetDefaultValues(this, { email: decodeURIComponent(email) })
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { registerApiEndpoint, createAccountPageUrl, passwordResetPageUrl } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: registerApiEndpoint,
          body: {
            username: form.email.value
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg, data } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                data,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda Registration Form",
                  pageAction: "MyMazda Registration Form - Register"
                })
                if (data === "NotUnique") {
                  setTimeout(
                    () => {
                      // add email to the query params
                      const createAcountURL = new urlHandler(createAccountPageUrl)
                      createAcountURL.setParam("email", form.email.value)
                      createAcountURL.redirect()
                    },
                    200
                  )
                }
                if (data === "AlreadyRegistered") {
                  setTimeout(
                    () => {
                      // add email to the query params
                      const createAcountURL = new urlHandler(passwordResetPageUrl)
                      createAcountURL.setParam("email", form.email.value)
                      createAcountURL.setParam("alreadyRegistered", "true")
                      createAcountURL.redirect()
                    },
                    200
                  )
                }
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  render() {
    const { buttonText = "Next", heading, blurb, registrationSuccessfulText } = this.props
    const { loading, success, data, errorMessage } = this.state

    if (success && data !== "NotUnique" && data !== "AlreadyRegistered") {
      return (
        <div className={classnames({ [styles.MyMazdaRegister]: true  })}>
          <div className={classnames({ [styles.MyMazdaRegisterForm]: true })}>
            <FormGroup>
              <MailIcon
                style={{
                  fill: "#101010",
                  height: "29px",
                  margin: "0 auto 1em",
                  width: "37px"
                }}
              />
              <HeroContent
                heading={"Verify your email"}
                description={registrationSuccessfulText || "We've sent you an email to confirm your details. Simply click the link in the email to confirm your registration."} />
              </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({ [styles.MyMazdaRegister]: true })}>
        <div className={classnames({ [styles.MyMazdaRegisterForm]: true })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <FormGroup>
              <H3 withDetails>{heading || "Create account"}</H3>
              <Content xmlString={blurb} />
            </FormGroup>
            <FormGroup>
              <InputEmail name="email" label="Email" {...fromLinkInputs(this, "email")} onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda Registration Form",
                    pageAction:
                      "MyMazda Registration Form - Entered \"EMAIL\""
                  })
                }} />
            </FormGroup>
            <FormGroup>
              <AlertList data={errorMessage} />
              <Button styleName="black" loading={loading} fullWidth {...formLinkSubmit(this, this._handleSubmit)}>
                {buttonText}
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default MyMazdaRegister



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaRegister/MyMazdaRegister.jsx